import type { ComponentTheme } from '../types/component-theme';

export default {
    slots: {
        root: 'flex flex-col items-center justify-content'
    }
} satisfies ComponentTheme;
